import { render, staticRenderFns } from "./CommercialPolicyDate.vue?vue&type=template&id=6d84e244&scoped=true&"
import script from "./CommercialPolicyDate.vue?vue&type=script&lang=js&"
export * from "./CommercialPolicyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84e244",
  null
  
)

export default component.exports